<template>
    <v-card>
        <v-img height="80" src="@/assets/images/fondo1.png">
            <v-row class="pa-4" align="center" justify="center">
                <v-col fluid>
                    <v-list-item-avatar color="purple" size="40" class="ma-0">
                        <v-icon size="30">school</v-icon>
                    </v-list-item-avatar>
                    <span class="headline black--text ma-4">Titulo</span>
                </v-col>
            </v-row>
        </v-img>
        <v-dialog v-model="dPriAlumnoModalDialog" persistent max-width="900px">
            <v-card>
                <v-card-title style="background-color:#455A64">
                    <v-form ref="refPriAlumno">
                        <v-row fluid>
                            <v-col cols="9" xm="12" sm="9" md="9" class="pa-1">
                                <v-text-field @keyup.enter="fuPriAlumnoSearch" v-model="dDNINombre" label="DNI o Codigo o Nombre" outlined prepend-inner-icon="credit_card" clearable :rules="[v => !!v || 'El campo es requerido']" :maxlength="120" counter autocomplete="off"></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-btn @click="fuPriAlumnoSearch" :loading="dPriAlumnoTable.loading" color="blue-grey" dark x-large>
                                    <v-icon large left>search</v-icon> Buscar por {{campoTipo}}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-title>
                <v-data-table
                    v-model="dPriAlumnoTable.selected"
                    :headers="dPriAlumnoTable.headers"
                    :items="dPriAlumnos"
                    :loading="dPriAlumnoTable.loading"
                    single-select
                    item-key="IdAlumno"
                    show-select
                    class="elevation-1">
                    <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning">No hay registros para mostrar.</v-alert></template>
                </v-data-table>
                <v-card-actions class="blue-grey darken-2">
                    <v-btn @click="fuPriAlumnoSelected()" color="green" dark><v-icon>check</v-icon> Seleccionar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="dPriAlumnoModalDialog = false" color="grey darken-4" dark><v-icon>close</v-icon> Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-tabs v-model="dTab" :background-color="dIdTitulo ? 'warning':'primary'">
            <v-tab @click="dIsSearch=true; dIdTitulo=null" href='#tab-1'><v-icon left>search</v-icon>Buscar</v-tab>
            <v-tab v-if="!dIsSearch" href='#tab-2'>{{ dIdTitulo ? 'EDITAR':'AGREGAR'}}</v-tab>
            <v-tab-item value='tab-1'>
                <v-form>
                    <v-container fluid>
                        <v-row fluid>
                            <v-col cols="12" sm="5" md="4" lg="3" class="pa-0">
                                <v-menu
                                    v-model="dFInicioMenu"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="dFInicio"
                                            label="Fecha Inicio"
                                            prepend-inner-icon="event_note"
                                            readonly
                                            filled
                                            :disabled="dIsUpdating"
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="dFInicio"
                                        @input="dFInicioMenu = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="3" md="4" lg="3" class="pa-0">
                                <v-menu
                                    v-model="dFFinMenu"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="dFFin"
                                            label="Fecha Fin"
                                            prepend-inner-icon="event_note"
                                            readonly
                                            filled
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="dFFin"
                                        @input="dFFinMenu = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="1" md="2" lg="3" class="pa-0">
                                <v-btn @click.prevent="fuTtltituloByestadoByFechas" :loading="dTable.loading" color="blue-grey" dark x-large><v-icon>search</v-icon> Buscar</v-btn>
                            </v-col>
                            <v-col cols="12" sm="1" md="2" lg="2" class="pa-0">
                                <v-btn @click="dPriAlumnoModalDialog = true; dIsSearchTitulo=true" color="blue-grey" dark x-large><v-icon large left>search</v-icon> Buscar Alumno</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
                <v-data-table :headers="dTable.headers" :items="dTtlTitulos" :loading="dTable.loading" :search="dTable.search" class="elevation-1">
                    <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning">No hay registros para mostrar.</v-alert></template>
                    <template v-slot:no-results><v-alert :value="true" color="warning" icon="warning">No se encontro ningun registro con su busqueda "{{ dTable.search }}".</v-alert></template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-menu bottom offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on"><v-icon>more_vert</v-icon></v-btn>
                            </template>
                            <v-list>
                                <v-list-item>
                                    <v-list-item-title><v-btn @click="fuGet(item.idTitulo)" color="warning" block><v-icon>edit</v-icon> Editar</v-btn></v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                </v-data-table>
            </v-tab-item>
            <v-tab-item value='tab-2'>
                <v-row>
                    <v-col cols="3">
                        <v-card>
                            <v-img src="@/assets/images/fondo1.png" height="150px">
                                <v-app-bar flat color="rgba(0, 0, 0, 0)">
                                    <v-toolbar-title class="title white--text pl-0">Alumno</v-toolbar-title>
                                </v-app-bar>
                                <v-row justify="space-around">
                                    <v-avatar size="80">
                                        <img v-if="dPriAlumno.Sexo=='F'" src="@/assets/images/user2.jpg" alt="Alumno">
                                        <img v-else src="@/assets/images/user1.jpg" alt="Postulante">
                                    </v-avatar>
                                </v-row>
                            </v-img>
                            <v-list two-line v-if="dPriAlumno.Alumno">
                                <v-list-item>
                                    <v-list-item-icon><v-icon>person</v-icon></v-list-item-icon>
                                    <v-list-item-content><v-list-item-subtitle>{{dPriAlumno.Alumno}}</v-list-item-subtitle><v-list-item-subtitle>Apellidos y Nombres</v-list-item-subtitle></v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-icon><v-icon>bookmark</v-icon></v-list-item-icon>
                                    <v-list-item-content><v-list-item-title>{{dPriAlumno.Servicio}}</v-list-item-title><v-list-item-subtitle>Carrera</v-list-item-subtitle></v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-icon><v-icon>credit_card</v-icon></v-list-item-icon>
                                    <v-list-item-content><v-list-item-title>{{dPriAlumno.DNI}}</v-list-item-title><v-list-item-subtitle>DNI</v-list-item-subtitle></v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-icon><v-icon>qr_code_2</v-icon></v-list-item-icon>
                                    <v-list-item-content><v-list-item-title><v-chip color="success" dark>{{dPriAlumno.Codigo}}</v-chip></v-list-item-title><v-list-item-subtitle>Codigo</v-list-item-subtitle></v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-col>
                    <v-col cols="9">
                        <v-form ref="refMain">
                            <v-card color="blue-grey" dark flat :loading="dIsUpdating">
                                <v-card-text fluid>
                                    <v-row>
                                        <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                                            <v-menu
                                                v-model="dFechaMenu"
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="dTtlTitulo.fechaEmision"
                                                        label="*Fecha Emision"
                                                        prepend-inner-icon="event_note"
                                                        readonly filled
                                                        v-bind="attrs"
                                                        :disabled="dIsUpdating"
                                                        v-on="on"
                                                        :rules="[v => !!v || 'El campo es requerido']"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="dTtlTitulo.fechaEmision"
                                                    @input="dFechaMenu = false"
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                                            <v-text-field v-model="dTtlTitulo.nroRegistroIESTP" label="*Nro Registro Instituto" filled prepend-inner-icon="book" :disabled="dIsUpdating" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= 40) || 'El campo debe ser menor de 255 caracteres.']" :maxlength="255" autocomplete="off"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                                            <v-select v-model="dTtlTitulo.nivelFormativo" label="Nivel Formativo" :items="['PROFESIONAL TECNICO', 'PROFESIONAL']" filled prepend-inner-icon="label" :disabled="dIsUpdating" :rules="[v => !!v || 'El campo es requerido']"></v-select>
                                        </v-col>
                                        <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                                            <v-select v-model="dTtlTitulo.periodoLectivo" label="Periodo Lectivo" :items="dPeriodos" filled prepend-inner-icon="date_range" :disabled="dIsUpdating" :rules="[v => !!v || 'El campo es requerido']"></v-select>
                                        </v-col>
                                        <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                                            <v-text-field v-model="dTtlTitulo.creditos" label="Creditos" filled type="number" :disabled="dIsUpdating" prepend-inner-icon="exposure" :maxlength="3" autocomplete="off"/>
                                        </v-col>
                                        <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                                            <v-text-field v-model="dTtlTitulo.codigoDocumento" label="* Codigo Titulo" filled prepend-inner-icon="qr_code" :disabled="dIsUpdating" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= 40) || 'El campo debe ser menor de 255 caracteres.']" :maxlength="255" autocomplete="off"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                                            <v-text-field v-model="dTtlTitulo.nroModulos" label="Nro de Modulos" filled type="number" :disabled="dIsUpdating" prepend-inner-icon="exposure" :maxlength="2" autocomplete="off"/>
                                        </v-col>
                                        <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                                            <v-text-field v-model="dTtlTitulo.nroConstanciaEgresado" label="*Nro Constancia Egresado" filled prepend-inner-icon="book" :disabled="dIsUpdating" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= 40) || 'El campo debe ser menor de 255 caracteres.']" :maxlength="255" autocomplete="off"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                                            <v-text-field v-model="dTtlTitulo.nroFut" label="*Nro de FUT" filled prepend-inner-icon="receipt" :disabled="dIsUpdating" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= 40) || 'El campo debe ser menor de 255 caracteres.']" :maxlength="255" autocomplete="off"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" xm="6" sm="4" md="3" class="pa-1">
                                            <v-text-field v-model="dTtlTitulo.codigoMINEDU" label="Codigo MINEDU" filled prepend-inner-icon="style" :disabled="dIsUpdating" :maxlength="255" autocomplete="off"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" xm="12" sm="6" md="2">
                                            <v-checkbox v-model="dTtlTitulo.impreso" label="Impreso"></v-checkbox>
                                        </v-col>                                        
                                        <v-col cols="12" xm="6" sm="6" md="4" class="pa-1">
                                            <v-combobox v-if="dTtlTitulo.impreso" label="Usuario que Imprimió" v-model="dTtlTitulo.impresoUsuario"
                                                :items="dPriPersonals" item-value="Personal" item-text="Personal" :return-object="false"
                                                filled prepend-inner-icon="assignment_ind" :disabled="dIsUpdating"></v-combobox>
                                        </v-col>
                                        <v-col cols="12" xm="12" sm="6" md="2">
                                            <v-checkbox v-model="dTtlTitulo.duplicado" label="Duplicado"></v-checkbox>
                                        </v-col>                                        
                                        <v-col cols="12" xm="6" sm="4" md="4" class="pa-1">
                                            <v-text-field v-if="dTtlTitulo.duplicado" v-model="dTtlTitulo.duplicadoMotivo" label="Motivo Duplicado" filled prepend-inner-icon="description" :disabled="dIsUpdating" :maxlength="255" autocomplete="off"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" xm="12" sm="6" md="2">
                                            <v-checkbox v-model="dTtlTitulo.idiomaExtranjero" label="Idioma Extranjero"></v-checkbox>
                                        </v-col>                                        
                                        <v-col cols="12" xm="6" sm="4" md="4" class="pa-1">
                                            <v-combobox v-if="dTtlTitulo.idiomaExtranjero" v-model="dTtlTitulo.idiomaExtranjeroDescripcion" label="Descripcion Idioma Extranjero" 
                                                :items="['','INGLES', 'FRANCES', 'PORTUGUES', 'QUECHUA']" :return-object="false"
                                                filled prepend-inner-icon="description" :disabled="dIsUpdating"></v-combobox>
                                        </v-col>
                                        <v-col cols="12" xm="12" sm="6" md="2">
                                            <v-checkbox v-model="dTtlTitulo.lenguaNativa" label="Lengua Nativa"></v-checkbox>
                                        </v-col>                                        
                                        <v-col cols="12" xm="6" sm="4" md="4" class="pa-1">
                                            <v-combobox v-if="dTtlTitulo.lenguaNativa" v-model="dTtlTitulo.lenguaNativaDescripcion" label="Descripcion Lengua Nativa" 
                                                :items="['','AIMARA', 'QUECHUA', 'SHIPIBO']" :return-object="false"
                                                filled prepend-inner-icon="description" :disabled="dIsUpdating"></v-combobox>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" xm="6" sm="6" md="7" class="pa-1">
                                            <v-textarea v-model="dTtlTitulo.observacion"
                                                label="Observación" auto-grow filled rows="2" row-height="15" :disabled="dIsUpdating" prepend-inner-icon="post_add"
                                            ></v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions>
                                    <v-btn @click.prevent="fuSave" :loading="dIsUpdating" :color="dIdTitulo ? 'warning':'primary'" ><v-icon>save</v-icon> Guardar</v-btn>
                                </v-card-actions>
                                <v-snackbar v-model="dSnackbar" color="red">Revise el formulario, existe datos erróneos.
                                    <v-btn text @click="dSnackbar = false"> Cerrar </v-btn>
                                </v-snackbar>
                            </v-card>
                        </v-form>
                    </v-col>
                </v-row>
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import moment from 'moment';
import gql from 'graphql-tag';
import {mapState} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
export default {
    name: 'Titulo',
    mounted(){
        this.fuLoad();
        if (typeof this.$route.params.pIdTitulacionModalidad != "undefined"){
            this.fuTtltitulacionmodalidad(this.$route.params.pIdTitulacionModalidad);
            this.dTtlTitulo.idTitulacionModalidad= this.$route.params.pIdTitulacionModalidad;
            this.dIsSearch=false;
            this.dTab='tab-2';
        }
        let vYearNow = new Date().getFullYear();
        for (var i = vYearNow; i >= vYearNow-20; i--) {
            this.dPeriodos.push(i+'-2');
            this.dPeriodos.push(i+'-1');
        }
    },
    data: () => ({
        dDNINombre:'',
        dFechaMenu: false,
        dFInicio: moment().subtract(90,'d').format('YYYY-MM-DD'),
        dFInicioMenu: false,
        dFFin: moment().format('YYYY-MM-DD'),
        dFFinMenu: false,
        dIdTitulo: null,
        dIsUpdating: false,
        dIsSearch: true,
        dIsSearchTitulo: false,
        dPeriodos: [],
        dPriAlumno: {
            DNI: '',
            Alumno: '',
            Sexo: '',
            Telefono: '',
            Codigo: '',
            Celular: '',
            Servicio: ''
        },
        dPriAlumnoDefault: {
            DNI: '',
            Alumno: '',
            Sexo: '',
            Telefono: '',
            Codigo: '',
            Celular: '',
            Servicio: ''
        },
        dPriAlumnos: [],
        dPriAlumnoModalDialog: false,
        dPriAlumnoTable: {
            headers: [
                {value: 'actions', text: '...', sortable: false},
                {value: 'IdAlumno', text: 'IdAlumno', align: ' d-none'},
                {value: 'Alumno', text: 'Alumno'},
                {value: 'DNI', text: 'DNI', align: 'center', sortable: false},
                {value: 'Codigo', text: 'Codigo'},
                {value: 'priservicio.Iniciales', text: 'Carrera', align: 'center', sortable: false},
                {value: 'Celular', text: 'Celular', align: 'center', sortable: false},
                {value: 'Telefono', text: 'Telefono', align: 'center', sortable: false},
                {value: 'Sexo', text: 'Sexo', align: ' d-none'},
            ],
            loading: false,
            selected: []
        },
        dPriPersonals: [],
        dSnackbar: false,
        dTab:0,
        dTable: {
            headers: [
                {value: 'actions', text: '...', sortable: false},
                {value: 'idTitulo', text: 'idTitulo', align: ' d-none'},
                {value: 'fechaEmision', text: 'F. Emision'},
                {value: 'prialumno.Alumno', text: 'Alumno'},
                {value: 'periodoLectivo', text: 'Periodo'},
                {value: 'nroRegistroIESTP', text: 'Nro Registro Instituto'},
                {value: 'codigoDocumento', text: 'Codigo Documento'},
                {value: 'nroConstanciaEgresado', text: 'Nro Constancia Egresado'}
            ],
            loading: false,
            search: null,
        },
        dTtlTitulos: [],
        dTtlTitulo: {
            fechaEmision: '',
            nroRegistroIESTP: '',
            nivelFormativo: 'TECNICO',
            periodoLectivo: '',
            creditos: '0',
            codigoDocumento: '',
            nroModulos: '3',
            nroConstanciaEgresado: '',
            nroFut: '',
            codigoMINEDU: '',
            impreso: false,
            impresoUsuario: '',
            duplicado: false,
            duplicadoMotivo: '',
            idiomaExtranjero: false,
            idiomaExtranjeroDescripcion: '',
            lenguaNativa: false,
            lenguaNativaDescripcion: '',
            observacion: '',
            IdAlumno: null,
            idTitulacionModalidad: null,
        },
        dTtlTituloDefault: {
            fechaEmision: '',
            nroRegistroIESTP: '',
            nivelFormativo: 'TECNICO',
            periodoLectivo: '',
            creditos: '0',
            codigoDocumento: '',
            nroModulos: '3',
            nroConstanciaEgresado: '',
            nroFut: '',
            codigoMINEDU: '',
            impreso: false,
            impresoUsuario: '',
            duplicado: false,
            duplicadoMotivo: '',
            idiomaExtranjero: false,
            idiomaExtranjeroDescripcion: '',
            lenguaNativa: false,
            lenguaNativaDescripcion: '',
            observacion: '',
            IdAlumno: null,
            idTitulacionModalidad: null,
        }
    }),
    methods: {
        fuAdd(){
            this.dTtlTitulo = Object.assign({}, this.dTtlTituloDefault);
            this.dPriAlumno = Object.assign({}, this.dPriAlumnoDefault);
            this.dIdTitulo=null;
            this.dIsSearch=false;
            this.dTab='tab-2';
        },
        async fuLoad(){
            try {
                const response = await this.$apollo.query({
                    query: gql`query load{
                        pripersonalByEstado(Estado:1){
                            Personal
                        }
                    }`
                })
                this.dPriPersonals = response.data.pripersonalByEstado;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Problema de Conexión.', 'error');
            } finally {
            }
        },
        async fuTtltituloByIdAlumno(vIdAlumno){
            this.dTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumno($IdAlumno: ID!){
                        prialumno(IdAlumno:$IdAlumno){
                            ttltitulos{
                                idTitulo
                                fechaEmision
                                periodoLectivo
                                nroRegistroIESTP
                                codigoDocumento
                                nroConstanciaEgresado
                                prialumno{
                                    Alumno
                                }
                            }
                        }
                    }`,
                    variables: {
                        IdAlumno: vIdAlumno
                    }
                })
                this.dTtlTitulos = [];
                this.dTtlTitulos = response.data.prialumno.ttltitulos;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
            } finally {
                this.dTable.loading = false
            }
        },
        async fuTtltituloByestadoByFechas(){
            this.dTable.loading = true;
            let vFInicio =this.dFInicio.substring(0,10).split("-").join("");
            let vFFin =this.dFFin.substring(0,10).split("-").join("");
            try {
                const response = await this.$apollo.query({
                    query: gql`query ttltitulobyestadoByFechas($FInicio: String!, $FFin: String!, $token: String){
                        ttltitulobyestadoByFechas(estado: 1, FInicio:$FInicio, FFin:$FFin, token: $token){
                            idTitulo
                            fechaEmision
                            periodoLectivo
                            nroRegistroIESTP
                            codigoDocumento
                            nroConstanciaEgresado
                            prialumno{
                                Alumno
                            }
                        }
                    }`,
                    variables: {
                        FInicio: vFInicio,
                        FFin: vFFin,
                        token: new Date().toISOString()
                    }
                })
                this.dTtlTitulos = [];
                this.dTtlTitulos = response.data.ttltitulobyestadoByFechas;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
            } finally {
                this.dTable.loading = false
            }
        },
        async fuTtltitulacionmodalidad(pidTitulacionModalidad) {
            try {
                const response = await this.$apollo.query({
                    query: gql`query ttltitulacionmodalidad($idTitulacionModalidad: ID!){
                        ttltitulacionmodalidad(idTitulacionModalidad: $idTitulacionModalidad){
                            prialumno{
                                IdAlumno
                                Alumno
                                DNI
                                Codigo
                                Celular
                                Telefono
                                Sexo
                                priservicio{
                                    Iniciales
                                }
                            }
                        }
                    }`,
                    variables: {
                        idTitulacionModalidad: pidTitulacionModalidad
                    }
                })
                console.log(response.data.ttltitulacionmodalidad);
                this.fumatmatriculaLast(response.data.ttltitulacionmodalidad.prialumno.IdAlumno)
                this.dTtlTitulo.IdAlumno = response.data.ttltitulacionmodalidad.prialumno.IdAlumno;
                this.dPriAlumno.DNI = response.data.ttltitulacionmodalidad.prialumno.DNI;
                this.dPriAlumno.Alumno = response.data.ttltitulacionmodalidad.prialumno.Alumno;
                this.dPriAlumno.Sexo = response.data.ttltitulacionmodalidad.prialumno.Sexo;
                this.dPriAlumno.Telefono = response.data.ttltitulacionmodalidad.prialumno.Telefono;
                this.dPriAlumno.Codigo = response.data.ttltitulacionmodalidad.prialumno.Codigo;
                this.dPriAlumno.Celular = response.data.ttltitulacionmodalidad.prialumno.Celular;
                this.dPriAlumno.Servicio = response.data.ttltitulacionmodalidad.prialumno.priservicio.Iniciales;
            } catch (error) {
                console.log(error);
            } finally {
            }
        },
        async fumatmatriculaLast(pIdAlumno) {
            try {
                const response = await this.$apollo.query({
                    query: gql`query matmatriculaLast($IdAlumno: ID!){
                        matmatriculaLast(IdAlumno: $IdAlumno){
                            matseccion{
                                matperiodo{
                                    Anio
                                    Periodo
                                }
                            }
                        }
                    }`,
                    variables: {
                        IdAlumno: pIdAlumno
                    }
                })
                console.log(response.data.matmatriculaLast[0].matseccion.matperiodo.Anio + '-' +response.data.matmatriculaLast[0].matseccion.matperiodo.Periodo);
                this.dTtlTitulo.periodoLectivo = response.data.matmatriculaLast[0].matseccion.matperiodo.Anio + '-' +response.data.matmatriculaLast[0].matseccion.matperiodo.Periodo;
            } catch (error) {
                console.log(error);
            } finally {
            }
        },
        fuPriAlumnoSearch(){
            if(this.dDNINombre==''){
                this.dSnackbar = true;
            } else {
                if(this.dDNINombre.length==8 && !isNaN(this.dDNINombre))
                    this.fuPrialumnoByDNI(this.dDNINombre)
                else{
                    if(this.dDNINombre.length==9 && !isNaN(this.dDNINombre.substring(0,5)))
                        this.fuPrialumnoByCodigo(this.dDNINombre)
                    else
                        this.fuPrialumnoByAlumno(this.dDNINombre)
                }
            }
        },
        async fuPrialumnoByCodigo(pCodigo) {
            this.dPriAlumnoTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumnoByCodigo($Codigo: String!){
                        prialumnoByCodigo(Codigo: $Codigo){
                            IdAlumno
                            Alumno
                            DNI
                            Codigo
                            Celular
                            Telefono
                            Sexo
                            priservicio{
                                Iniciales
                            }
                        }
                    }`,
                    variables: {
                        Codigo: pCodigo
                    }
                })
                console.log(response.data.prialumnoByCodigo);
                this.dPriAlumnos = [];
                this.dPriAlumnos.push(response.data.prialumnoByCodigo);
            } catch (error) {
                console.log(error);
            } finally {
                this.dPriAlumnoTable.loading = false
            }
        },
        async fuPrialumnoByDNI(pDni) {
            this.dPriAlumnoTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumnoByDNI($DNI: String!){
                        prialumnoByDNI(DNI: $DNI){
                            IdAlumno
                            Alumno
                            DNI
                            Codigo
                            Celular
                            Telefono
                            Sexo
                            priservicio{
                                Iniciales
                            }
                        }
                    }`,
                    variables: {
                        DNI: pDni
                    }
                })
                console.log(response.data.prialumnoByDNI);
                this.dPriAlumnos = response.data.prialumnoByDNI;
            } catch (error) {
                console.log(error);
            } finally {
                this.dPriAlumnoTable.loading = false
            }
        },
        async fuPrialumnoByAlumno(pAlumno) {
            this.dPriAlumnoTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumnoByAlumno($Alumno: String!){
                        prialumnoByAlumno(Alumno: $Alumno){
                            IdAlumno
                            Alumno
                            DNI
                            Codigo
                            Celular
                            Telefono
                            Sexo
                            priservicio{
                                Iniciales
                            }
                        }
                    }`,
                    variables: {
                        Alumno: pAlumno
                    }
                })
                console.log(response.data.prialumnoByAlumno);
                this.dPriAlumnos = response.data.prialumnoByAlumno;
            } catch (error) {
                console.log(error);
            } finally {
                this.dPriAlumnoTable.loading = false
            }
        },
        fuPriAlumnoSelected(){
            if(!this.dPriAlumnoTable.selected){
                Swal.fire('Información', 'Debe seleccionar un elemento', 'info')
            } else {
                if(this.dPriAlumnoTable.selected.length==0)
                    Swal.fire('Información', 'Debe seleccionar un elemento', 'info')
                else{
                    if(this.dIsSearchTitulo){
                        this.fuTtltituloByIdAlumno(this.dPriAlumnoTable.selected[0].IdAlumno);
                        this.dIsSearchTitulo=false;
                    } else {
                        this.dTtlTitulacionModalidad.IdAlumno = this.dPriAlumnoTable.selected[0].IdAlumno;
                        this.dPriAlumno.DNI = this.dPriAlumnoTable.selected[0].DNI;
                        this.dPriAlumno.Alumno = this.dPriAlumnoTable.selected[0].Alumno;
                        this.dPriAlumno.Sexo = this.dPriAlumnoTable.selected[0].Sexo;
                        this.dPriAlumno.Telefono = this.dPriAlumnoTable.selected[0].Telefono;
                        this.dPriAlumno.Codigo = this.dPriAlumnoTable.selected[0].Codigo;
                        this.dPriAlumno.Celular = this.dPriAlumnoTable.selected[0].Celular;
                        this.dPriAlumno.Servicio = this.dPriAlumnoTable.selected[0].priservicio.Iniciales;
                    }
                    this.dPriAlumnoModalDialog = false;
                }
            }
        },
        fuSave(){
            let vError='';
            if(!this.dTtlTitulo.IdAlumno) vError+='Ingrese el Alumno.<br>';
            if(this.dTtlTitulo.impreso && this.dTtlTitulo.impresoUsuario =='') vError+='Ingrese usuario que imprimió.<br>';
            if(this.dTtlTitulo.duplicado && this.dTtlTitulo.duplicadoMotivo =='') vError+='Ingrese motivo duplicado.<br>';
            if(this.dTtlTitulo.idiomaExtranjero && this.dTtlTitulo.idiomaExtranjeroDescripcion =='') vError+='Ingrese Descripción de Idioma extranjero.<br>';
            if(this.dTtlTitulo.lenguaNativa && this.dTtlTitulo.lenguaNativaDescripcion =='') vError+='Ingrese Descripción de Lengua Nativa.<br>';

            if(vError!=''){
                Swal.fire({
                            icon: 'error',
                            title: '¡ ERROR !',
                            html: 'Revise el formulario, existe datos erróneos.<br>' +vError
                        })
            } else {
                if(!this.$refs.refMain.validate()){
                    this.dSnackbar = true;
                } else {
                    if (!this.dIdTitulo)
                        this.fuCreate();
                    else
                        this.fuUpdate();
                }
            }
        },
        async fuCreate () {
            try {
                this.dIsUpdating = true;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation ttltituloCreate($input: ttltituloCreateInput!){
                        ttltituloCreate(input: $input){
                            idTitulo
                        }
                    }`,
                    variables: {
                        input: this.dTtlTitulo
                    }
                });
                console.log(response.data);
                if(response.data){
                    this.dIdTitulo = response.data.ttltituloCreate.idTitulo;
                    Swal.fire('Correcto', 'Se guardó correctamente', 'success')
                } else {
                    Swal.fire('¡ ERROR !', 'No se guardó.', 'error')
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se guardó.', 'error')
            } finally {
                this.dIsUpdating = false;
            }
        },
        async fuUpdate () {
            try {
                this.dIsUpdating = true;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation ttltituloUpdate($idTitulo: ID!, $input: ttltituloUpdateInput!){
                        ttltituloUpdate(idTitulo: $idTitulo, input: $input){
                            idTitulo
                        }
                    }`,
                    variables: {
                        idTitulo: this.dIdTitulo,
                        input: this.dTtlTitulo
                    }
                });
                console.log(response.data);
                if(response.data){
                    Swal.fire('Correcto', 'Se modificó correctamente', 'success')
                } else {
                    Swal.fire('¡ ERROR !', 'No se modificó.', 'error')
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se modificó.', 'error')
            } finally {
                this.dIsUpdating = false;
            }
        },
        async fuGet(pIdTitulo){
            this.dIdTitulo = pIdTitulo;
            this.dTab='tab-2';
            this.dIsSearch=false;
            try {
                this.dIsUpdating = true;

                const response = await this.$apollo.query({
                    query: gql`query ttltitulo($idTitulo: ID!, $token: String){
                        ttltitulo(idTitulo:$idTitulo, token: $token){
                            fechaEmision
                            nroRegistroIESTP
                            nivelFormativo
                            periodoLectivo
                            creditos
                            codigoDocumento
                            nroModulos
                            nroConstanciaEgresado
                            nroFut
                            codigoMINEDU
                            impreso
                            impresoUsuario
                            duplicado
                            duplicadoMotivo
                            idiomaExtranjero
                            idiomaExtranjeroDescripcion
                            lenguaNativa
                            lenguaNativaDescripcion
                            observacion
                            IdAlumno
                            idTitulacionModalidad
                            prialumno{
                                IdAlumno
                                Alumno
                                DNI
                                Codigo
                                Celular
                                Telefono
                                Sexo
                                priservicio{
                                    Iniciales
                                }
                            }
                        }
                    }`,
                    variables: {
                        idTitulo: pIdTitulo,
                        token: new Date().toISOString()
                    }
                })
                console.log(response.data);
                if(response.data){
                    this.dTtlTitulo.fechaEmision = response.data.ttltitulo.fechaEmision;
                    this.dTtlTitulo.nroRegistroIESTP = response.data.ttltitulo.nroRegistroIESTP;
                    this.dTtlTitulo.nivelFormativo = response.data.ttltitulo.nivelFormativo;
                    this.dTtlTitulo.periodoLectivo = response.data.ttltitulo.periodoLectivo;
                    this.dTtlTitulo.creditos = response.data.ttltitulo.creditos;
                    this.dTtlTitulo.codigoDocumento = response.data.ttltitulo.codigoDocumento;
                    this.dTtlTitulo.nroModulos = response.data.ttltitulo.nroModulos;
                    this.dTtlTitulo.nroConstanciaEgresado = response.data.ttltitulo.nroConstanciaEgresado;
                    this.dTtlTitulo.nroFut = response.data.ttltitulo.nroFut;
                    this.dTtlTitulo.codigoMINEDU = response.data.ttltitulo.codigoMINEDU;
                    this.dTtlTitulo.impreso = response.data.ttltitulo.impreso;
                    this.dTtlTitulo.impresoUsuario = response.data.ttltitulo.impresoUsuario;
                    this.dTtlTitulo.duplicado = response.data.ttltitulo.duplicado;
                    this.dTtlTitulo.duplicadoMotivo = response.data.ttltitulo.duplicadoMotivo;
                    this.dTtlTitulo.idiomaExtranjero = response.data.ttltitulo.idiomaExtranjero;
                    this.dTtlTitulo.idiomaExtranjeroDescripcion = response.data.ttltitulo.idiomaExtranjeroDescripcion;
                    this.dTtlTitulo.lenguaNativa = response.data.ttltitulo.lenguaNativa;
                    this.dTtlTitulo.lenguaNativaDescripcion = response.data.ttltitulo.lenguaNativaDescripcion;
                    this.dTtlTitulo.observacion = response.data.ttltitulo.observacion;
                    this.dTtlTitulo.IdAlumno = response.data.ttltitulo.IdAlumno;
                    this.dTtlTitulo.idTitulacionModalidad = response.data.ttltitulo.idTitulacionModalidad;
                    
                    this.dPriAlumno.DNI = response.data.ttltitulo.prialumno.DNI;
                    this.dPriAlumno.Alumno = response.data.ttltitulo.prialumno.Alumno;
                    this.dPriAlumno.Sexo = response.data.ttltitulo.prialumno.Sexo;
                    this.dPriAlumno.Telefono = response.data.ttltitulo.prialumno.Telefono;
                    this.dPriAlumno.Codigo = response.data.ttltitulo.prialumno.Codigo;
                    this.dPriAlumno.Celular = response.data.ttltitulo.prialumno.Celular;
                    this.dPriAlumno.Servicio = response.data.ttltitulo.prialumno.priservicio.Iniciales;
                } else {
                    Swal.fire('¡ ERROR !', 'No se recuperó el registro.', 'error')
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se recuperó el registro.', 'error')
            } finally {
                this.dIsUpdating = false;
            }
        }
    },
    watch: {
        'dTtlTitulo.impreso': function (newVal, oldVal){
            if(newVal===false)
                this.dTtlTitulo.impresoUsuario ='';
            else{
                if(!this.dIdTitulo)
                    this.dTtlTitulo.impresoUsuario = this.ssUser.Personal;
            }
        },
        'dTtlTitulo.duplicado': function (newVal, oldVal){
            if(newVal===false) this.dTtlTitulo.duplicadoMotivo ='';
        },
        'dTtlTitulo.idiomaExtranjero': function (newVal, oldVal){
            if(newVal===false) this.dTtlTitulo.idiomaExtranjeroDescripcion ='';
        },
        'dTtlTitulo.lenguaNativa': function (newVal, oldVal){
            if(newVal===false) this.dTtlTitulo.lenguaNativaDescripcion ='';
        },
    },
    computed: {
        ...mapState(['ssUser']),
        campoTipo: function () {
            if(this.dDNINombre==''){
                return '';
            } else {
                if(this.dDNINombre.length==8 && !isNaN(this.dDNINombre))
                    return 'DNI';
                else{
                    if(this.dDNINombre.length==9 && !isNaN(this.dDNINombre.substring(0,5)))
                        return 'Codigo';
                    else
                        return 'Nombre';
                }
            }
        }
    }
}
</script>